import React, { PureComponent } from 'react';
import RowAutorizacionesRechazadas from './RowAutorizacionesRechazadas';
import SelectorFecha from '../SelectorFecha';
import ModalDatosCuenta from '../ModalDatosCuenta';

class AutorizacionesRechazadas extends PureComponent {

    constructor(props) {
        super(props);
    }

    componentDidUpdate() {
        $('[data-toggle="tooltip"]').tooltip();
    }

    componentDidMount() {
        $('[data-toggle="tooltip"]').tooltip();
        if(this.props.data.datosCuentaGenerales){
            this.props.actions.getScreenDataAutorizaciones(this.props.cuentaId)
        }
    }

    validarFecha(fecha){
        let fechaAux = fecha.split("/");
        let diaAux, mesAux, fechaFinal;

        if(fechaAux[0].length == 1)
            diaAux = "0" + fechaAux[0];
        else
            diaAux = fechaAux[0];

        if(fechaAux[1].length == 1)
            mesAux = "0" + fechaAux[1];
        else
            mesAux = fechaAux[1];

        fechaFinal = diaAux + "/" + mesAux + "/" + fechaAux[2];
        
        return fechaFinal
    }
 
    render() {
        
        const { data, actions } = this.props;
        const {AutorizacionesRechazadas} =  data;
        const { SinAutorizaciones, autorizacionesParaMostrar } = AutorizacionesRechazadas;
        let spinner,textoToolTip="",fechaCalendarioDesde, fechaCalendarioHasta;
        
        if (AutorizacionesRechazadas.loading == true) spinner = <div className="loading" />
        
        textoToolTip = SinAutorizaciones || (SinAutorizaciones && autorizacionesParaMostrar.length < 1) ?
        AutorizacionesRechazadas.textoToolTip
        : "";

        //Validación para fecha que se muestra en el calendario
        if (typeof (AutorizacionesRechazadas.fechaDesde) == "object") {
            fechaCalendarioDesde = AutorizacionesRechazadas.fechaDesde.toLocaleDateString();
            fechaCalendarioDesde = fechaCalendarioDesde.length <= 9 ? this.validarFecha(fechaCalendarioDesde) : fechaCalendarioDesde;
        }
        else if (typeof AutorizacionesRechazadas.fechaDesde == "string" && AutorizacionesRechazadas.fechaDesde.length > 10) {
            fechaCalendarioDesde = new Date().toLocaleDateString();
            fechaCalendarioDesde = fechaCalendarioDesde.length <= 9 ? this.validarFecha(fechaCalendarioDesde) : fechaCalendarioDesde;
        }
        else if (typeof AutorizacionesRechazadas.fechaDesde == "string") {
            fechaCalendarioDesde = AutorizacionesRechazadas.fechaDesde;
            fechaCalendarioDesde = fechaCalendarioDesde.length <= 9 ? this.validarFecha(fechaCalendarioDesde) : fechaCalendarioDesde;
        }

        //Validación para fecha que se muestra en el calendario
        if (typeof (AutorizacionesRechazadas.fechaHasta) == "object") {
            fechaCalendarioHasta = AutorizacionesRechazadas.fechaHasta.toLocaleDateString();
            fechaCalendarioHasta = fechaCalendarioHasta.length <= 9 ? this.validarFecha(fechaCalendarioHasta) : fechaCalendarioHasta;
        }
        else if (typeof AutorizacionesRechazadas.fechaHasta == "string" && AutorizacionesRechazadas.fechaHasta.length > 10) {
            fechaCalendarioHasta = new Date().toLocaleDateString();
            fechaCalendarioHasta = fechaCalendarioHasta.length <= 9 ? this.validarFecha(fechaCalendarioHasta) : fechaCalendarioHasta;
        }
        else if (typeof AutorizacionesRechazadas.fechaHasta == "string") {
            fechaCalendarioHasta = AutorizacionesRechazadas.fechaHasta;
            fechaCalendarioHasta = fechaCalendarioHasta.length <= 9 ? this.validarFecha(fechaCalendarioHasta) : fechaCalendarioHasta;
        }

        if(!data.AutorizacionesRechazadas.mostrarCalendariosAutorizaciones) actions.mostrarCalendariosAutorizaciones()

        return (            
            <div className="container-fluid">
                <div>{spinner}</div>
                {AutorizacionesRechazadas.getAutorizaciones &&
                    <ModalDatosCuenta
                        ocultarModal={actions.ocultarModalAutorizaciones}
                        titulo="Autorizaciones Rechazadas"
                        mensaje={AutorizacionesRechazadas.mensajeAutorizaciones}
                    />
                }
                <div className="col-md-12 contenedor-Fechas-Cuenta-Corriente">
                    <div className='CuentaSeleccionContainerCuentaCorriente'>
                        <div className="MovimientosLabel">
                            <p className="Movimientos">Rechazo</p>
                        </div>
                    </div>
                    <div className='CuentaSeleccionContainerCuentaCorriente tableroProcesosPanelSuperior' >
                        <div className='CuentaSeleccionContainerCuentaCorriente'>
                            {AutorizacionesRechazadas && AutorizacionesRechazadas.limpiarFechas && 
                                (AutorizacionesRechazadas.formatoFechaDesdeAutorizaciones && AutorizacionesRechazadas.formatoFechaHastaAutorizaciones) &&
                                    <div>
                                        <button ref={(buttonDOM) => { this.buttonDOM = buttonDOM; }} data-toggle="tooltip"
                                            data-title='Eliminar selección de fechas.' data-placement="left" className='botonEliminarFiltroDatosCuenta'
                                            onClick={() => actions.limpiarAutorizaciones()}>
                                        </button>
                                    </div>
                            }
                            {AutorizacionesRechazadas && AutorizacionesRechazadas.mostrarCalendariosAutorizaciones && 
                                <div>
                                    <div className="marginLeft-DatosCuenta1">
                                        <SelectorFecha
                                            fArguments={["fecha"]}
                                            claseContainer={"DatosCuenta__seccionFiltrosFechasSuperiores DatosCuenta__seccionFiltrosFechas DatosCuenta--floatLeft DatosCuenta__fechaDesdeMargin"}
                                            validarFormatoFechaDesde={actions.FormatoFechaDesde}
                                            validarFormatoFechaHasta={actions.FormatoFechaHasta}
                                            fecha={fechaCalendarioDesde}
                                            keyDate={"fecha-desde"}
                                            clasePicker={"date-picker-CuentaCorriente-1 form-control-Datos-Cuenta marginLeft-DatosCuenta1"}
                                            titulo={"Desde"}
                                            maxToday={true}
                                            textoInput={AutorizacionesRechazadas.textoInputDesde}
                                            classLabel="labelDatosCuentaDesde"
                                        />         
                                        {AutorizacionesRechazadas && (AutorizacionesRechazadas.errorFechaDesdeAutorizaciones || AutorizacionesRechazadas.FechaDesdePosteriorAutorizaciones) && <label className="error labelErrorDesde">{AutorizacionesRechazadas.msjErrorCalendarioDesde}</label>}                       
                                    </div>
                                </div>
                            }
                            {AutorizacionesRechazadas && AutorizacionesRechazadas.mostrarCalendariosAutorizaciones && 
                                <div className="marginLeft-DatosCuenta2">
                                    <div>
                                        <SelectorFecha
                                            fArguments={["fecha"]}
                                            claseContainer={"DatosCuenta__seccionFiltrosFechasSuperiores DatosCuenta__seccionFiltrosFechas Procesos--floatLeft DatosCuenta__fechaDesdeMargin"}
                                            validarFormatoFechaDesde={actions.FormatoFechaDesde}
                                            validarFormatoFechaHasta={actions.FormatoFechaHasta}
                                            fecha={fechaCalendarioHasta}
                                            keyDate= "fecha-hasta"
                                            maxToday={true}
                                            clasePicker= "date-picker-CuentaCorriente-2 form-control-Datos-Cuenta marginLeft-DatosCuenta-Calendario-2"
                                            titulo= "Hasta"
                                            textoInput={AutorizacionesRechazadas.textoInputHasta}
                                            classLabel="labelDatosCuentaHasta"
                                        />           
                                        {AutorizacionesRechazadas && (AutorizacionesRechazadas.errorFechaHastaAutorizaciones || AutorizacionesRechazadas.FechaHastaPosteriorAutorizaciones) && <label className="error labelErrorHasta">{AutorizacionesRechazadas.msjErrorCalendarioHasta}</label>}                         
                                    </div>
                                </div>
                            }
                            <div className="col-md-1 lineMenuCuentaCorriente">
                                <button onClick={() => actions.buscarAutorizaciones(fechaCalendarioDesde, fechaCalendarioHasta)} className='botonCuentaCorriente'>Ver</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div>
                    <table className='width100 noBorder tableAutorizacionesRechazadas'>
                        <thead className='saldoHeaderBorde'>
                            <tr className='height50 EditIcon paddingLeftXS paddingTopBottom'>
                                <th width="20%">FECHA / HORA</th>
                                <th width="21%">N° DE TARJETA</th>
                                <th width="15%">ESTABLECIMIENTO</th>
                                <th width="28%">MOTIVO DE RECHAZO</th>
                                <th width="9%">IMPORTE CONVERSIÓN</th>
                                <th width="9%">IMPORTE PESIFICADO</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {AutorizacionesRechazadas && AutorizacionesRechazadas.autorizacionesParaMostrar.length > 0
                                ?
                                AutorizacionesRechazadas.autorizacionesParaMostrar.map((autorizaciones, index) => { 
                                   return <RowAutorizacionesRechazadas 
                                            index={index} 
                                            autorizaciones={autorizaciones}
                                            datosAutorizacion={actions.datosAutorizacion}/> }) 
                                :
                                <tr className='Personeria paddingLeftXS paddingTopBottom'>
                                    <td colSpan="5">{AutorizacionesRechazadas.mensajeSinAutorizaciones}</td>
                                </tr>
                            }                            
                        </tbody>
                    </table>
                    <table className='width100 noBorder'>
                        <tr>
                            {textoToolTip != "" ?
                                <p data-toggle="tooltip" key={textoToolTip} title={textoToolTip} data-placement="top" >
                                    <button onClick={() => actions.actualizarAutorizacionesParaMostrar()} disabled={SinAutorizaciones} className='btn btn-primary btn-cta width100 botonVerMas'>Ver más</button>
                                </p>
                                :
                                <button onClick={() => actions.actualizarAutorizacionesParaMostrar()} disabled={SinAutorizaciones} className='btn btn-primary btn-cta width100 botonVerMas'>Ver más</button>}
                        </tr>
                    </table>
                </div>
            </div>
        );
    }
}

export default AutorizacionesRechazadas;
